import React from 'react';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import { ReactComponent as LogoSmall } from '../../assets/images/logo/logo-small.svg';
import { ReactComponent as LogoLarge } from '../../assets/images/logo/logo.svg';


import './style.scss';

const Logo = ({ small }) => {
  const classNames = c('Logo', {
    'Logo--small-only': small,
  });

  return (
    <div className={classNames}>
      <CoreLink to="/">
        <LogoSmall className="Logo__small" />
        <LogoLarge className="Logo__large" />
      </CoreLink>
    </div>
  );
};

export default Logo;
